module.exports = __webpack_public_path__ + "static/img/ayusa.e523dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ayusa.png
// module id = BJPK
// module chunks = 10